<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" :rules="rules" ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="materialName" label="物料名称">
              <el-input v-model="formData.materialName" placeholder="请输入物料名称" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>

          <el-col :span="12">
            <el-form-item prop="materialSpec" label="物料规格">
              <el-input v-model="formData.materialSpec" placeholder="请输入物料规格" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="materialType" label="物料类型">
              <el-input v-model="formData.materialType" placeholder="请输入物料类型" />
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'MaterialsManageAdd',
  data () {
    return {
      specList: [],
      formData: {
        materialName: '',
        materialSpec: '',
        materialType: ''
      },
      rules: {
        materialName: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],
        materialSpec: [{ required: true, message: '请输入物料规格', trigger: 'blur' }],
        materialType: [{ required: true, message: '请输入物料类型', trigger: 'blur' }]
      }
    }
  },
  created () {
    if (this.materialId) {
      this.loadData()
    }
  },
  computed: {
    materialId () {
      return this.$route.query.materialId
    }

  },
  methods: {

    loadData () {
      this.$axios.get(this.$apis.materialsManage.selectYcMaterialByMaterialId, {
        params: { materialId: this.materialId }
      }).then(res => {
        this.formData = res || {}
      })
    },

    submit () {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.materialsManage.insertYcMaterial
        if (this.materialId) {
          url = this.$apis.materialsManage.updateYcMaterial
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
